// extracted by mini-css-extract-plugin
module.exports = {"measuresFormInfo":"measuresForm_measuresFormInfo__DcpLu","saveButton":"measuresForm_saveButton__kavvD"};